export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev-stezq8d6okitd0uz.us.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'Kr25NcanvcwFxBOpqKl8Mil1pQ3Aiq50',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'https://dev-stezq8d6okitd0uz.us.auth0.com/api/v2/',
  redirectUri: window.location.origin,
};
